export default __webpack_public_path__ + "static/media/denizbank.1ad15ba4.png";